// extracted by mini-css-extract-plugin
module.exports = {"player_details":"yD4dN","player_image":"SZ1Nc","player_name":"GoXNa","player_position":"XOASh","player_top_score":"FpAEB","runs":"ZWzDy","inn":"DxB0k","avg":"eYlAJ"};